









import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'
import { getPersonFromZone } from '@/modules/common/zone/helper/zone.helper'

@Component
export default class TelegramActivationButton extends Vue {
  constructor(
    private readonly userBootUseCase: UserBootUseCase
  ) {
    super()
  }

  @Prop({ default: true }) isVerified!: boolean
  @Prop({ required: false, default: undefined }) url!: string
  person = getPersonFromZone()

  get telegramRoute() {
    return this.url || this.userBootUseCase.user.bot_activation[this.person]
  }

  onClick() {
    window.open(this.telegramRoute, '_blank')
  }
}
